type ProductListingGlobal = 'setCardHeight';

export const callProductListing = (name: ProductListingGlobal): void => {
  const fn = window[name];
  if (typeof fn !== 'function') return;

  try {
    fn();
  } catch (error) {
    console.error(`[FitAssistant] window.${name}() failed`, error);
  }
};
